<template>
    <div>

		<header id="header" class="full-header">
			<div id="header-wrap" class="">
				<div class="container">
					<div class="header-row top-search-parent">

						<!-- Logo
						============================================= -->
						<div id="logo">
							<h3 class="mb-0">E-oficinas</h3>
						</div><!-- #logo end -->

						<div id="primary-menu-trigger">
							<svg class="svg-trigger" viewBox="0 0 100 100"><path d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20"></path><path d="m 30,50 h 40"></path><path d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20"></path></svg>
						</div>

						<!-- Primary Navigation
						============================================= -->
						<nav class="primary-menu">

							<ul class="menu-container">
								<li class="menu-item sub-menu">
									<router-link to="/eoficinas" class="menu-link" style="padding-top: 39px; padding-bottom: 39px;"><div>Painel</div></router-link>
								</li>
								<li class="menu-item sub-menu">
									<router-link to="/eoficinas/configuracoes/1/editar" class="menu-link" style="padding-top: 39px; padding-bottom: 39px;"><div>Configurações</div></router-link>
								</li>
								<li class="menu-item sub-menu">
									<router-link to="/eoficinas/banners" class="menu-link" style="padding-top: 39px; padding-bottom: 39px;"><div>Banners</div></router-link>
								</li>
								<li class="menu-item sub-menu">
									<router-link to="/eoficinas/depoimentos" class="menu-link" style="padding-top: 39px; padding-bottom: 39px;"><div>Depoimentos</div></router-link>
								</li>
								<li class="menu-item sub-menu">
									<router-link to="/eoficinas/segmentos" class="menu-link"  style="padding-top: 39px; padding-bottom: 39px;"><div>Segmentos</div></router-link>
								</li>
								<li class="menu-item sub-menu">
									<a class="menu-link" style="padding-top: 39px; padding-bottom: 39px;"><div>Sites<i class="icon-angle-down"></i></div></a>
									<ul class="sub-menu-container" style="">
										<li class="menu-item" style="">
											<router-link to="/autoespecialistas" class="menu-link"><div>AutoEspecialistas</div></router-link>
										</li>
										<li class="menu-item" style="">
											<router-link to="/gape/paineldegerenciamento" class="menu-link"><div>Gape</div></router-link>
										</li>
										<li class="menu-item" style="">
											<router-link to="/esinistros" class="menu-link"><div>E-sinistros</div></router-link>
										</li>
										<li class="menu-item" style="">
											<router-link to="/eoficinas" class="menu-link"><div>E-oficinas</div></router-link>
										</li>
										<li class="menu-item" style="">
											<router-link to="/paineldegerenciamento/blog" class="menu-link"><div>Blog</div></router-link>
										</li>
										<li class="menu-item" style="">
											<router-link to="/paineldegerenciamento" class="menu-link"><div>Sistema</div></router-link>
										</li>
									</ul>
								</li>

								<li class="menu-item sub-menu">
									<a @click.prevent="fnLogout()" class="menu-link" style="padding-top: 39px; padding-bottom: 39px; cursor:pointer"><div>Logout</div></a>
								</li>
							</ul>

						</nav><!-- #primary-menu end -->

					</div>
				</div>
			</div>
		</header>
		<div id="page-menu" class="no-sticky">
			<div id="page-menu-wrap">
				<div class="container">
					<div class="page-menu-row">

						<div class="page-menu-title" style="padding:10px 0;">&nbsp;</div>

					</div>
				</div>
			</div><div class="page-menu-wrap-clone" style="height: 48px;"></div>
		</div>		
    </div>
</template>

<script>
import {userKey} from '../global/utils'
import {mapState} from 'vuex'
export default {
		data() {
			return {
			}
		},
		mounted() {
			this.updateList()
		},
		watch: {
		'$route' () {
		this.updateList()
		}
		},
		props:['secaoPrincipal','idUsu'],
		computed: {
			map: function(){
				return	mapState(['eoficinas','navSecao'])
			}
		},
		methods: {
		fnRouteTo(pRouteTo){
			if(this.breadcrumbList[pRouteTo].link) this.$router.push(this.breadcrumbList[pRouteTo].link)
		},
		updateList(){
			this.breadcrumbList = this.$route.meta.breadcrumb
		},
		fnMostraMenu(event){
			event.target.parentElement && event.target.nextSibling.classList.toggle("show");
		},
		toggleMenu(){
			this.$store.commit('toggleMenu');
		},
		fnLogout(){
			localStorage.removeItem(userKey);
			this.$store.commit('setUser',null)
			this.$router.push("../eoficinas/auth")
		}
	},

}
</script>

<style lang="less" scoped>
	#header-wrap{
		position: relative;
	}
	@media (min-width: 992px){
		.page-menu-sub-menu {
			min-width: 225px;
		}
	}
	#page-menu{
		margin-bottom: 45px !important;
	}
		

</style>